import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("header", null, null, -1)

import yHeader from '@/components/header/index.vue'
  import { defineComponent, reactive, computed, onMounted } from 'vue'
  import { ElConfigProvider } from 'element-plus'
  import zhCn from 'element-plus/lib/locale/lang/zh-cn'
  import { useRouter } from 'vue-router'
  
export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

  const locale = zhCn
  const router = useRouter()
  const showHeader = computed(() => {
    const { path } = router.currentRoute.value
    return !path.includes('/paySuccess')
  })
  onMounted(() => {
    document.dispatchEvent(new Event('render-event'))
  })

return (_ctx: any,_cache: any) => {
  const _component_metainfo = _resolveComponent("metainfo")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_unref(ElConfigProvider), { locale: _unref(locale) }, {
    default: _withCtx(() => [
      _createVNode(_component_metainfo, null, {
        title: _withCtx(({ content }) => [
          _createTextVNode(_toDisplayString(content ? `${content} | SITE_NAME` : `SITE_NAME`), 1)
        ]),
        _: 1
      }),
      _hoisted_1,
      (showHeader.value)
        ? (_openBlock(), _createBlock(yHeader, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(_component_router_view)
    ]),
    _: 1
  }, 8, ["locale"]))
}
}

})